import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Legal.css'; // We'll use shared CSS for all legal pages

function AGB() {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1 className="legal-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
        
        <section className="legal-section">
          <h2>§ 1 Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen der Musterfirma GmbH (nachfolgend "Anbieter") und dem Kunden (nachfolgend "Kunde") über die Nutzung der Plattform abgeschlossen werden.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 2 Vertragsschluss</h2>
          <p>
            Der Vertrag kommt zustande durch die Annahme des Angebots des Anbieters durch den Kunden. Die Annahme erfolgt durch Registrierung auf der Plattform.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 3 Leistungen des Anbieters</h2>
          <p>
            Der Anbieter stellt dem Kunden eine Plattform zur Verfügung, die folgende Funktionen umfasst: [Beschreibung der Hauptfunktionen].
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 4 Pflichten des Kunden</h2>
          <p>
            Der Kunde verpflichtet sich, wahrheitsgemäße Angaben zu machen und die Plattform nicht für illegale Zwecke zu nutzen.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 5 Bezahlung</h2>
          <p>
            Für kostenpflichtige Leistungen gelten die zum Zeitpunkt des Vertragsschlusses veröffentlichten Preise. Die Zahlung erfolgt gemäß den angegebenen Zahlungsmodalitäten.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 6 Kündigung</h2>
          <p>
            Der Vertrag kann von beiden Parteien mit einer Frist von [Zeitraum] gekündigt werden. Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 7 Haftung</h2>
          <p>
            Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten.
          </p>
        </section>

        <section className="legal-section">
          <h2>§ 8 Schlussbestimmungen</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist [Ort], sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
          </p>
        </section>

        <div className="legal-footer">
          <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          <Link to="/" className="home-link">← Zurück zur Startseite</Link>
        </div>
      </div>
    </div>
  );
}

export default AGB;